import { rydeColors } from "@ryde/theme";

/** Matches the Leaflet walking polyline: `color: vividPurple, dashArray: "4, 4", weight: 3`. */
export const WALKING_ROUTE_COLOR = rydeColors.vividPurple;
export const WALKING_ROUTE_WIDTH_PX = 3;
export const WALKING_ROUTE_DASH_ARRAY = "4, 4";

/** Gap (px) between the walking line and its hover tooltip — Leaflet used a [10, 10] offset. */
export const WALKING_ROUTE_TOOLTIP_OFFSET_PX = 10;

/** Widened transparent line under the visible one, so a 3px dashed path is still easy to hover. */
export const WALKING_ROUTE_HIT_WIDTH_PX = 12;

/**
 * Marks the walking tooltip's popup so a screen can style just that one. It is the Leaflet `<Tooltip>`'s
 * successor and carries its bordered-card look, which must NOT leak onto the plain address popups sharing
 * the same map — on Leaflet those were `<Popup>`s and never matched the `.leaflet-tooltip` rule.
 */
export const WALKING_ROUTE_POPUP_CLASS = "maplibre-walking-route-popup";

/** A line needs two positions before there is anything to draw between. */
export const WALKING_ROUTE_MIN_POSITIONS = 2;
